import React from 'react';
import PropTypes from 'prop-types';
import {Form, Select} from 'antd';
import {selectAuth} from '@app/redux/selectors';
import {connect} from 'react-redux';
import {RqSystemLov} from '@app/reactQuery/apis/rqCommonAPI';
import {SortOptions} from '@app/components/common/Filters/SortOptions';

const SingleSelectLeaveTypeAttribute = ({auth, attributeMetadata, formValues}) => {

  const {data} = RqSystemLov({
    certificate: auth?.certificate,
    category: 'LEAVE_TYPE',
  });

  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  return (
    <Form.Item
      name={[attributeMetadata.id]}
      label={attributeMetadata.label}
      rules={attributeMetadata.validation_rules}
    >
      <Select
        allowClear={true}
        showSearch
        filterOption={filterOption}
        placeholder={attributeMetadata?.placeholder}
        disabled={!attributeMetadata.editable}
        options={SortOptions(data)?.map((object, index) => {
          return {
            value: object?.id,
            label: object?.name,
          };
        })}
      />
    </Form.Item>
  );
};

SingleSelectLeaveTypeAttribute.propTypes = {
  auth: PropTypes.shape({
    certificate: PropTypes.string.isRequired,
  }).isRequired,
  attributeMetadata: PropTypes.shape({
    id: PropTypes.string.isRequired,
    partName:PropTypes.string,
    editable: PropTypes.bool,
    validation_rules: PropTypes.array,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    input_search_enable: PropTypes.bool,
    input_parent_division_id: PropTypes.string.isRequired,
    input_parent_type_id: PropTypes.string.isRequired,
  }).isRequired,
  formValues: PropTypes.object,
};

const mapState = state => {
  const auth = selectAuth(state);
  return {auth};
};

export default connect(mapState)(SingleSelectLeaveTypeAttribute);
